import {
  SET_BREADCRUMB_NAVIGATION_STATE,
  SET_SIDENAV_STATE,
} from './webGalleryLayoutActions';

export const initialState = {
  sideNavExpanded: false,
  breadcrumbNavigationEnabled: true,
};

const webGalleryLayoutReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_SIDENAV_STATE: {
      return {
        ...state,
        sideNavExpanded: action.expanded,
      };
    }
    case SET_BREADCRUMB_NAVIGATION_STATE: {
      return {
        ...state,
        breadcrumbNavigationEnabled: action.enabled,
      };
    }
    default:
      return state;
  }
};

export default webGalleryLayoutReducer;
